import type { UploadRequestOption } from 'rc-upload/lib/interface'
import { httpClientPrivate } from './httpClientPrivate'

export const uploadRequest = (options: UploadRequestOption) => {
  const formData = new FormData()
  formData.append(options.filename || 'file', options.file)
  Object.entries(options.data || {}).forEach(([key, value]) => {
    formData.append(key, String(value))
  })

  httpClientPrivate
    .post(options.action, formData, {
      onUploadProgress: (event) => {
        if (event.total) {
          options.onProgress?.({ percent: (event.loaded / event.total) * 100 })
        }
      },
    })
    .then((response) => options.onSuccess?.(response.data))
    .catch((error) => options.onError?.(error))
}
